import { Pipe, PipeTransform } from '@angular/core';
import { EqualOr, ProposalFieldState } from '@shared/pipes/is-equal.pipe';

@Pipe({ standalone: false, name: 'equalOrCalculable' })
export class EqualOrCalculablePipe implements PipeTransform {
  transform(value: EqualOr<number>): 'calculable' | 'not-calculable' | 'equal' {
    if (value === ProposalFieldState.EQUAL) return 'equal';
    if (!value) return 'not-calculable';

    return 'calculable';
  }
}
